import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  linesStore: [],
  subLinesState: [],
  directionsStore: [],
  stopsLine: [],
  overlappingLines: [],
  selectedLine: null,
  selectedSubLine: null,
  selectedLineDirection: null,
  showAllItineraries:false,
  allItineraries:[]
};

export const linesSlice = createSlice({
  name: 'linesSlice',
  initialState,
  reducers: {
    updateLines: (state, action) => {
      state.linesStore = action.payload;
    },
    updateSubLines: (state, action) => {
      state.subLinesState = action.payload;
    },
    updateLine: (state, action) => {
      state.linesStore = action.payload;
    },
    updateStopsLine: (state, action) => {
      state.stopsLine = action.payload;
    },
    updateSelectedLine: (state, action) => {
      state.selectedLine = action.payload;
    },
    updateOverlappingLines: (state, action) => {
      state.overlappingLines = action.payload;
    },
    updateSelectedSubLine: (state, action) => {
      state.selectedSubLine = action.payload;
    },
    updateDirections: (state, action) => {
      state.directionsStore = action.payload;
    },
    updateSelectedLineDirection: (state, action) => {
      state.selectedLineDirection = action.payload;
    },
    updateShowAllItineraries: (state, action) => {
      state.showAllItineraries = action.payload;
    },
    updateAllItineraries: (state, action) => {
      state.allItineraries = action.payload;
    },
  },
});

export const {
  updateLines,
  updateSelectedLine,
  updateSelectedLineDirection,
  updateSelectedSubLine,
  updateSubLines,
  updateStopsLine,
  updateDirections,
  updateOverlappingLines,
  updateShowAllItineraries,
  updateAllItineraries,
} = linesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const lineState = (state: RootState) => state.lines.linesStore;
export const subLineState = (state: RootState) => state.lines.subLinesState;
export const directionsState = (state: RootState) => state.lines.directionsStore;
export const selectedLineState = (state: RootState) => state.lines.selectedLine;
export const selectedSubLineState = (state: RootState) => state.lines.selectedSubLine;
export const selectedLineDirectionState = (state: RootState) => state.lines.selectedLineDirection;
export const stopsLinesState = (state: RootState) => state.lines.stopsLine;
export const overlappingLines = (state: RootState) => state.lines.overlappingLines;
export const showAllItinerariesState = (state: RootState) => state.lines.showAllItineraries;
export const allItinerariesState = (state: RootState) => state.lines.allItineraries;

export default linesSlice.reducer;
